"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatingManufacturingInfo = void 0;
const common_1 = require("../../common");
class EstimatingManufacturingInfo extends common_1.MongoSubDocument {
}
exports.EstimatingManufacturingInfo = EstimatingManufacturingInfo;
//# sourceMappingURL=estimating-manufacturing-info.model.js.map